import { useMemo } from "react";
import { Input } from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { ClockIcon as Clock } from "@phosphor-icons/react";

// Campo ora con input manuale + popover a destra con lista orari allo step indicato.
export function TimeField({ value, onChange, step = 30, disabled = false, testid }) {
  const times = useMemo(() => {
    const out = [];
    const s = Math.max(5, Number(step) || 30);
    for (let m = 0; m < 24 * 60; m += s) {
      out.push(`${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`);
    }
    return out;
  }, [step]);
  return (
    <div className="relative flex items-center">
      <Input type="time" value={value || ""} onChange={(e) => onChange(e.target.value)} disabled={disabled}
        className="rounded-sm h-9 pr-8 time-field-input" data-testid={testid} step={Number(step) * 60} />
      {!disabled && (
        <Popover>
          <PopoverTrigger asChild>
            <button type="button" className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-primary" data-testid={testid ? `${testid}-clock` : undefined} tabIndex={-1}>
              <Clock size={15} />
            </button>
          </PopoverTrigger>
          <PopoverContent className="w-24 p-1 rounded-sm" align="start" side="right">
            <div className="max-h-56 overflow-auto">
              {times.map((t) => (
                <button key={t} type="button" onClick={() => onChange(t)}
                  className={`w-full px-2 py-1 rounded-sm text-sm text-left hover:bg-secondary ${value === t ? "bg-secondary font-medium" : ""}`}
                  data-testid={testid ? `${testid}-opt-${t}` : undefined}>{t}</button>
              ))}
            </div>
          </PopoverContent>
        </Popover>
      )}
    </div>
  );
}
